import { APP_STORES, type AppStoreAudience, type AppStoreKind } from '@/utils/appStores';
import { recordStoreLinkClick, type StoreInterestButton } from '@/utils/storeInterest';
import { cn } from '@/lib/utils';

const liveClassName =
  'inline-flex min-h-11 items-center justify-center rounded-xl bg-[#1E3A8A] px-5 py-3 text-sm font-semibold text-white hover:bg-[#1E40AF] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1E3A8A] focus-visible:ring-offset-2';

const comingSoonClassName =
  'inline-flex min-h-11 items-center justify-center rounded-xl border border-slate-300 bg-white px-5 py-3 text-sm font-semibold text-slate-600';

interface StoreDownloadButtonsProps {
  device?: AppStoreAudience;
  className?: string;
}

/**
 * Live stores keep the real store URL. Each tap is recorded without changing
 * where the link goes. Unlisted stores are a non-clickable “coming soon” label
 * so visitors never land on App Not Available.
 */
const storeButtonFor = (platform: AppStoreKind): StoreInterestButton =>
  platform === 'ios' ? 'app_store' : 'play_store';

const StoreDownloadButtons = ({ device = 'desktop', className }: StoreDownloadButtonsProps) => {
  const platforms: AppStoreKind[] = device === 'desktop' ? ['ios', 'android'] : [device];

  return (
    <div className={cn('flex flex-wrap items-center justify-center gap-3', className)}>
      {platforms.map((platform) => {
        const store = APP_STORES[platform];
        if (store.available) {
          const storeButton = storeButtonFor(platform);
          return (
            <a
              key={platform}
              href={store.url}
              className={liveClassName}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => recordStoreLinkClick(storeButton)}
              onAuxClick={() => recordStoreLinkClick(storeButton)}
            >
              {store.label}
            </a>
          );
        }
        return (
          <span key={platform} className={comingSoonClassName}>
            {store.comingSoonLabel}
          </span>
        );
      })}
    </div>
  );
};

export default StoreDownloadButtons;
